import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const AddToolTip = ({
  name,
  className,
  toolTipSafeHarbour,
  children = null,
  placement,
  style = {},
  width,
  displayTooltip = true
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  //const slicedName = (name || "").slice(0, length);
  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        showTooltip ? (
          <Tooltip style={{ zIndex: 999999 }}>{name}</Tooltip>
        ) : (
          <div></div>
        )
      }
    >
      <div
        className={className}
        onMouseEnter={() => (displayTooltip) ? setShowTooltip(true) : setShowTooltip(false)}
        onMouseLeave={() => setShowTooltip(false)}
        style={{
          textOverflow: "ellipsis",
          maxWidth: "100%",
          overflow: "hidden",
          whiteSpace: "nowrap",
          ...style,
        }}
      >
        {children ? children : name}
      </div>
    </OverlayTrigger>
  );
};

export default AddToolTip;
